import React from "react";
import {
  ModalOverlay,
  ModalContainer,
  ModalContent,
  ModalIcon,
  ModalTitle,
  ModalMessage,
  ModalActions,
  ModalButton,
} from "./ConfirmationModal.styled";

const ConfirmationModal = ({
  open,
  title,
  message,
  onClose,
  onConfirm,
  buttonText = "Delete",
  colorCode,
}) => {
  if (!open) return null;
  
  return (
    <ModalOverlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalContent>
          <ModalIcon colorCode={colorCode}>!</ModalIcon>
          <ModalTitle>{title}</ModalTitle>
          <ModalMessage dangerouslySetInnerHTML={{ __html: message }} />
          <ModalActions>
            <ModalButton variant="outlined" onClick={onClose}>
              Cancel
            </ModalButton>
            <ModalButton
              variant="contained"
              onClick={onConfirm}
              colorCode={colorCode}
            >
              {buttonText}
            </ModalButton>
          </ModalActions>
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default ConfirmationModal;
